import moment from 'moment'
import Vue from 'vue'

export const formatCurrency = (value: number, isCts:boolean = true, local:string='fr-FR', currency:string = 'EUR') => {  
  if (value || value === 0) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency,
        minimumFractionDigits:0,
        maximumFractionDigits:2
      }).format(value/(isCts?100.0:1))     
  }
}

Vue.filter('currency', formatCurrency)

export const formatCurrencyNo = (value: number, isCts:boolean = true, local:string='fr-FR') => {  
  if (value || value === 0) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'decimal',
        minimumFractionDigits:0,
        maximumFractionDigits:2
      }).format(value/(isCts?100.0:1))     
  }
}

Vue.filter('noCurrency', formatCurrencyNo)